export default { sha: '66bd63b04c65ca623012d366e9ab2d8f64047c61', buildNumber: 'undefined' }
